(function() {
  "use strict";

  angular
    .module("emails")
    .controller("SendToUserController", SendToUserController);
  SendToUserController.$inject = [
    "$state",
    "$timeout",
    "$stateParams",
    "ExpoService",
    "CampaignsService",
    "HowMuchService",
    "WhoPayService",
    "CountriesNewService",
    "LanguagesService",
    "SeminarsService",
    "PlanService",
    "embed",
    "edit",
    "mode",
    "$uibModal",
    "$scope",
    "toastr",
    "AudienceService",
    "ProfileTypeService",
    "VirtualFairService"
  ];
  function SendToUserController(
    $state,
    $timeout,
    $stateParams,
    ExpoService,
    CampaignsService,
    HowMuchService,
    WhoPayService,
    CountriesNewService,
    LanguagesService,
    SeminarsService,
    PlanService,
    embed,
    edit,
    mode,
    $uibModal,
    $scope,
    toastr,
    AudienceService,
    ProfileTypeService,
    VirtualFairService
  ) {
    var vm = this;
    vm.datePicker = { autoApply: true };
    vm.userEmail = "";
    vm.campaingInsertedId = {};
    vm.embed = embed;
    vm.edit = edit;
    vm.mode = mode;
    vm.userLanguageSelected = [];
    vm.userAvoidLanguageSelected = [];
    vm.countryRegionCitiesSelected = {};
    vm.countryRegionCitiesAvoidedSelected = {};
    vm.courseSelected = [];
    vm.userLanguageList = [];
    vm.userFilterTypeSelected = [];
    vm.profileTypeList = [];
    vm.profileTypeSelected = [];
    vm.userFilterTypeList = [
      { name: "Students", id: "student" },
      { name: "Institutions", id: "institution" },
      { name: "Agents", id: "agent" },
      { name: "Governments Agents", id: "government" },
      { name: "Others", id: "other" }
    ];
    vm.byPassVirtualFair = 0;
    vm.isATokenAudience = 0;
    vm.byPassPhysicalFair = 0;
    vm.userAgeSelected = [];
    vm.userAgeList = [];
    vm.userInterestedProfileTypesSelected = [];
    vm.userInterestedProfileTypesList = [
      { name: "Language", id: "language" },
      { name: "Undergrad", id: "university" },
      { name: "Secondary", id: "boarding" },
      { name: "Short-Term", id: "extension" },
      { name: "Postgrad", id: "graduate" },
      { name: "MBA", id: "mba" },
      { name: "Vocational", id: "vocational" },
      { name: "Online", id: "online" }
    ];
    vm.registeredAtPhysicalFairSelected = [];
    vm.registeredAtPhysicalFairList = [
      { name: " ", id: "-1" },
      { name: "All", id: "all" },
      { name: "Hotsite", id: "0" },
      { name: "Edufindme", id: "1" },
      { name: "Fair Reception", id: "2" }
    ];
    vm.userInterestedCountryList = [];
    vm.userInterestedCountrySelected = [];
    vm.userWhoPaysSelected = [];
    vm.userWhoPaysList = [];
    vm.userHowMuchSelected = [];
    vm.userHowMuchList = [];
    vm.userStudiedAbroadSelected = [];
    vm.userStudiedAbroadList = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.seminarConfirmedSelected = [];
    vm.seminarRegisteredSelected = [];
    vm.seminarConfirmedList = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.dateRangeCreateionDate = [];
    vm.dateRangeDispatchDate = [];
    vm.sendDate = [];
    vm.confirmedPhysicalFairSelected = [];
    vm.confirmedPhysicalFair = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.registeredInPhysicalFairSelected = [];
    vm.registeredInPhysicalFair = [
      { name: " " },
      { name: "All", id: -1 },
      { name: "Hotsites", id: 0 },
      { name: "Edufindme", id: 1 },
      { name: "Fair Reception", id: 2 }
    ];
    vm.attendedPhysicalFairSelected = [];
    vm.attendedPhysicalFair = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.attendedVirtualFairSelected = [];
    vm.attendedVirtualFair = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.confirmedVirtualFairSelected = [];
    vm.confirmedVirtualFair = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.micrositeVirtualFairSelected = [];
    vm.micrositesVirtualFair = [];
    vm.sendDateOptions = {
      singleDatePicker: true,
      timePicker: true,
      timePickerIncrement: 30,
      locale: {
        format: "MM/DD/YYYY h:mm A"
      }
    };
    vm.seminarRegisteredSelected = [];
    vm.seminarRegisteredList = [];
    vm.seminarConfirmedSelected = [];
    vm.seminarConfirmedList = [
      { name: " " },
      { name: "Both" },
      { name: "Yes" },
      { name: "No" }
    ];
    vm.query = {};
    vm.campaignTypeList = [
      { id: "promotions", name: "Promotions" },
      { id: "expo", name: "EXPO Announcements" },
      { id: "news", name: "News" }
    ];
    vm.campaignTypeSelected = [];
    vm.campaigns = [];
    vm.campaignTitle = "";
    vm.userCountrySelected = [];
    vm.userHaveAPlanSelected = [];
    vm.userHaveAPlanList = [];
    vm.physicalFairRegisteredSelected = [];
    vm.physicalFairNotRegisteredSelected = [];
    vm.physicalFairList = [];
    vm.virtualFairRegisteredSelected = [];
    vm.virtualFairNotRegisteredSelected = [];
    vm.virtualFairList = [];
    vm.noResultMessage = "";
    vm.avoidCountryListComponent = false;
    vm.countryListComponent      = false;
    vm.physicalRequired = true;
    vm.virtualRequired = true;
    vm.resultCalculate = 0;
    vm.isCalculate = false;
    vm.fillForm = fillForm;
    vm.selectPhysicalFair = selectPhysicalFair;
    vm.selectVirtualFair = selectVirtualFair;
    vm.onChangeFilter = onChangeFilter;
    vm.onChangeisATokenAudience = onChangeisATokenAudience;
    vm.getByFilter = getByFilter;
    vm.updateCampaign = updateCampaign;
    vm.createCampaign = createCampaign;
    vm.selectHowMuch = selectHowMuch;
    vm.selectWhoPays = selectWhoPays;
    vm.selectInterestedCountry = selectInterestedCountry;
    vm.selectLanguages = selectLanguages;
    vm.selectSeminars = selectSeminars;
    vm.selectPlans = selectPlans;
    vm.onChangeType = onChangeType;
    vm.calculate = calculate;
    vm.calculateAudience = calculateAudience;
    vm.clearPhysicalFairFields = clearPhysicalFairFields;
    vm.clearVirtualFairFields = clearVirtualFairFields;
    vm.selectProfiles = selectProfiles;
    vm.getMicrositesByVirtualExpo = getMicrositesByVirtualExpo;
    vm.checkVirtualFairLength = checkVirtualFairLength;

    /*PAGINATION*/
    vm.pageChanged = pageChanged;
    vm.setPage = setPage;
    vm.totalItems = [];
    vm.to = [];
    vm.currentPage = null;
    vm.itemsPerPage = [];
    vm.page = 1;

    function activate() {
      var ageList = [];
      for (var i = 10; i <= 100; i++) {
        ageList.push({ age: i });
      }
      vm.selectHowMuch();
      vm.selectWhoPays();
      vm.selectInterestedCountry();
      vm.selectSeminars();
      vm.userAgeList = ageList;
      vm.selectPhysicalFair();
      vm.selectVirtualFair();
      vm.selectProfiles();
      vm.selectPlans();
      vm.selectLanguages();
      if ($stateParams.audienceId) {
        vm.fillForm($stateParams.audienceId);
      }
    }

    function selectHowMuch() {
      HowMuchService.getAll()
        .then(function(response) {
          vm.userHowMuchList = response.data;
        })
        .catch(function(err) {});
    }

    function onChangeType() {
      vm.userAgeSelected = [];
      vm.userInterestedProfileTypesSelected = [];
      vm.registeredAtPhysicalFairSelected = [];
      vm.userInterestedCountrySelected = [];
      vm.userWhoPaysSelected = [];
      vm.userStudiedAbroadSelected = [];
      vm.seminarConfirmedSelected = [];
      vm.userHowMuchSelected = [];
      vm.seminarRegisteredSelected = [];
      vm.dateRangeCreateionDate = [];
      vm.dateRangeDispatchDate = [];
      vm.sendDate = [];
      vm.confirmedPhysicalFairSelected = [];
      vm.registeredInPhysicalFairSelected = [];
      vm.attendedPhysicalFairSelected = [];
      vm.attendedVirtualFairSelected = [];
      vm.confirmedVirtualFairSelected = [];
      vm.micrositeVirtualFairSelected = [];
      vm.seminarRegisteredSelected = [];
      vm.seminarConfirmedSelected = [];
      vm.query = {};
      vm.campaignTypeSelected = [];
      vm.campaigns = [];
      vm.userCountrySelected = [];
      vm.userHaveAPlanSelected = [];
      vm.physicalFairRegisteredSelected = [];
      vm.physicalFairNotRegisteredSelected = [];
      vm.virtualFairRegisteredSelected = [];
      vm.virtualFairNotRegisteredSelected = [];
      vm.governmentBasedCountrySelected = [];
      vm.governmentRepresentCountrySelected = [];
      vm.noResultMessage = "";
      vm.physicalRequired = true;
      vm.virtualRequired = true;
      vm.byPassVirtualFair = 0;
      vm.isATokenAudience = 0;
      vm.byPassPhysicalFair = 0;
    }

    function selectHowMuch() {
        HowMuchService.getAll().then(function(response){
            vm.userHowMuchList =  response.data;
        }).catch(function(err) {
        });
    }

    function onChangeType() {
        vm.userAgeSelected                      = [];
        vm.userInterestedProfileTypesSelected   = [];
        vm.registeredAtPhysicalFairSelected     = [];
        vm.userInterestedCountrySelected        = [];
        vm.userWhoPaysSelected                  = [];
        vm.userStudiedAbroadSelected            = [];
        vm.seminarConfirmedSelected             = [];
        vm.userHowMuchSelected                  = [];
        vm.seminarRegisteredSelected            = [];
        vm.dateRangeCreateionDate               = [];
        vm.dateRangeDispatchDate                = [];
        vm.sendDate                             = [];
        vm.confirmedPhysicalFairSelected        = [];
        vm.registeredInPhysicalFairSelected     = [];
        vm.attendedPhysicalFairSelected         = [];
        vm.attendedVirtualFairSelected         = [];
        vm.confirmedVirtualFairSelected         = [];
        vm.micrositeVirtualFairSelected         = [];
        vm.seminarRegisteredSelected            = [];
        vm.seminarConfirmedSelected             = [];
        vm.query                                = {};
        vm.campaignTypeSelected                 = [];
        vm.campaigns                            = [];
        vm.userCountrySelected                  = [];
        vm.userHaveAPlanSelected                = [];
        vm.physicalFairRegisteredSelected       = [];
        vm.physicalFairNotRegisteredSelected    = [];
        vm.virtualFairRegisteredSelected        = [];
        vm.virtualFairNotRegisteredSelected     = [];
        vm.governmentBasedCountrySelected       = [];
        vm.governmentRepresentCountrySelected   = [];
        vm.noResultMessage                      = '';
        vm.physicalRequired                     = true;
        vm.virtualRequired                      = true;
    }

    function selectInterestedCountry() {
        CountriesNewService.getCountries().then(function(response){
            vm.userInterestedCountryList = response.data;
        }).catch(function(err) {
        });
    }

    function selectWhoPays() {
        WhoPayService.getAll().then(function(response){
            vm.userWhoPaysList = response.data;
        }).catch(function(err) {
        });
    }

    function selectLanguages() {
        LanguagesService.getAllLanguages().then(function(response){
            vm.userLanguageList = response.data;
        }).catch(function(err) {
        });
    }

    function selectSeminars() {
        SeminarsService.getAllSeminars().then(function(response){
            vm.seminarRegisteredList = response.data;
        }).catch(function(err) {
        });
    }

    function selectPlans() {
        PlanService.getPlans().then(function(response){
            vm.userHaveAPlanList = response.data;
        }).catch(function(err) {
        });
    }

    function  fillForm(audienceId) {
      var query = [];
      var hash = Math.floor(Date.now() / 1000);
      query["id"] = audienceId;
      AudienceService.editAudience(query)
        .then(function(response) {
          if (response.data.length) vm.flag = true;
          vm.form = JSON.parse(angular.toJson(response.data));
          $timeout(function() {
            if (vm.mode == "replicate")
              vm.campaignTitle = vm.form.title + " - Copy " + hash;
            else vm.campaignTitle = vm.form.title;
            vm.userEmail = vm.form.user_filters.audience_students_email;
            vm.userLanguageSelected =
              vm.form.user_filters.audience_students_language;
            vm.userAvoidLanguageSelected =
              vm.form.user_filters.audience_avoided_students_language;
            vm.userFilterTypeSelected =
              vm.form.user_filters.audience_students_type;
            vm.userAgeSelected = vm.form.user_filters.audience_students_age;

            vm.userInterestedCountrySelected =
              vm.form.user_filters.audience_students_country;
            vm.userInterestedProfileTypesSelected =
              vm.form.user_filters.audience_students_studied_profile_type;
            vm.userStudiedAbroadSelected =
              vm.form.user_filters.audience_students_studied_abroad;
            vm.userWhoPaysSelected =
              vm.form.user_filters.audience_students_who_pays;
            vm.userHowMuchSelected =
              vm.form.user_filters.audience_students_how_much;
            /* VIRTUAL FAIR */
            vm.isATokenAudience =
              vm.form.user_filters.audience_students_virtual_fair_token_audience;
            vm.virtualFairNotRegisteredSelected =
              vm.form.user_filters.audience_students_virtual_fair_not_registered;
            vm.virtualFairRegisteredSelected =
              vm.form.user_filters.audience_students_virtual_fair_registered;
              vm.getMicrositesByVirtualExpo();
            vm.confirmedVirtualFairSelected =
              vm.form.user_filters.audience_students_virtual_fair_confirmed;
            vm.attendedVirtualFairSelected =
              vm.form.user_filters.audience_students_virtual_fair_attended;
            vm.micrositeVirtualFairSelected =
              vm.form.user_filters.audience_students_virtual_fair_microsite;
            vm.byPassVirtualFair =
              vm.form.user_filters.audience_students_virtual_fair_bypass;

            /* PHYSICAL FAIR */
            vm.physicalFairNotRegisteredSelected =
              vm.form.user_filters.audience_students_physical_fair_not_registered;
            vm.physicalFairRegisteredSelected =
              vm.form.user_filters.audience_students_physical_fair_registered;
            vm.registeredAtPhysicalFairSelected =
              vm.form.user_filters.audience_students_physical_fair_registered_at;
            vm.confirmedPhysicalFairSelected =
              vm.form.user_filters.audience_students_physical_fair_confirmed;
            vm.attendedPhysicalFairSelected =
              vm.form.user_filters.audience_students_physical_fair_attended;
            vm.byPassPhysicalFair =
              vm.form.user_filters.audience_students_physical_fair_bypass;
            /* STUDENTS -> SEMINAR */
            vm.seminarRegisteredSelected =
              vm.form.user_filters.audience_students_seminar;
            vm.seminarConfirmedSelected =
              vm.form.user_filters.audience_students_seminar_confirmed;
            /* INSTITUTIONS */
            vm.userCountrySelected = vm.form.user_filters.audience_country;
            vm.userHaveAPlanSelected =
              vm.form.user_filters.audience_have_a_plan;
            vm.governmentBasedCountrySelected =
              vm.form.user_filters.government_based_country;
            vm.governmentRepresentCountrySelected =
              vm.form.user_filters.government_represent_country;
            vm.profileTypeSelected = vm.form.user_filters.audience_profile_type;
            vm.countryRegionCitiesSelected = JSON.parse(
              angular.toJson(vm.form.user_filters.audience_students_cities)
            );
            vm.countryRegionCitiesAvoidedSelected = JSON.parse(
              angular.toJson(vm.form.user_filters.audience_avoided_students_cities)
            );
          },0);        
          if (vm.form.user_filters.audience_students_type.id === "student") {
            vm.courseSelected = JSON.parse(
              angular.toJson(vm.form.user_filters.course)
            );
          }
        })
        .catch(function(err) {});
    }

    function getByFilter() {
      /* STUDENTS -> USER */
      if (typeof vm.campaignTitle !== "undefined") {
        vm.query["audience_title"] = vm.campaignTitle;
      }
      if (typeof vm.userEmail !== "undefined") {
        vm.query["audience_students_email"] = vm.userEmail;
      }
      if (typeof vm.userLanguageSelected !== "undefined") {
        vm.query["audience_students_language"] = vm.userLanguageSelected;
      }
      if (typeof vm.userAvoidLanguageSelected !== "undefined") {
        vm.query["audience_avoided_students_language"] = vm.userAvoidLanguageSelected;
      }

      if (typeof vm.userFilterTypeSelected !== "undefined") {
        vm.query["audience_students_type"] = vm.userFilterTypeSelected;
      }
      if (vm.userFilterTypeSelected.id === "government") {
        if (!vm.governmentRepresentCountrySelected !== "undefined") {
          vm.query["government_represent_country"] =
            vm.governmentRepresentCountrySelected;
        }
      }
      if (typeof vm.userAgeSelected !== "undefined") {
        vm.query["audience_students_age"] = vm.userAgeSelected;
      }

      if (typeof vm.profileTypeSelected !== "undefined") {
        vm.query["audience_profile_type"] = vm.profileTypeSelected;
      }

      if (
        vm.userFilterTypeSelected.id === "student" ||
        vm.userFilterTypeSelected.id === "institution" ||
        vm.userFilterTypeSelected.id === "agent"
      ) {
        vm.query["audience_students_cities"] = vm.countryRegionCitiesSelected
        vm.query["audience_avoided_students_cities"] = vm.countryRegionCitiesAvoidedSelected;
      }

      if (vm.userFilterTypeSelected.id === "student") {
        if ($stateParams.audienceId) {
            if(typeof vm.courseSelected !== "undefined") {
              vm.query["course"] = {
                interest_course: [],
                interest_language: [],
                profile_type: []
              };
              if ( vm.courseSelected.interest_course && vm.courseSelected.interest_course.length > 0) {
                  vm.query['course'].interest_course = vm.courseSelected.interest_course;
              }
              if (vm.courseSelected.interest_language && vm.courseSelected.interest_language.length > 0) {
                  vm.query['course'].interest_language = vm.courseSelected.interest_language;
              }
              if (typeof vm.courseSelected.profile_type !== 'undefined') {
                vm.query['course'].profile_type = vm.courseSelected.profile_type;
                if (vm.courseSelected.profile_type === -1) {
                  vm.query['course'].profile_type = [];
                }
              }
            }
            if (typeof vm.userEmail !== 'undefined') {
                vm.query['audience_students_email'] = vm.userEmail;
            }
            if (typeof vm.userLanguageSelected !== 'undefined') {
                vm.query['audience_students_language'] = vm.userLanguageSelected;
            }
            if (typeof vm.userAvoidLanguageSelected !== 'undefined') {
                vm.query['audience_avoided_students_language'] = vm.userAvoidLanguageSelected;
            }
            if (typeof vm.userFilterTypeSelected !== 'undefined') {
                vm.query['audience_students_type'] = vm.userFilterTypeSelected;
            }
            if (vm.userFilterTypeSelected.id === 'government') {
                if (!vm.governmentRepresentCountrySelected !== 'undefined') {
                    vm.query['government_represent_country'] = vm.governmentRepresentCountrySelected;
                }
                if (!vm.governmentBasedCountrySelected !== 'undefined') {
                    vm.query['government_based_country'] = vm.governmentBasedCountrySelected;
                }
            }

            if (typeof vm.userAgeSelected !== 'undefined') {
                vm.query['audience_students_age'] = vm.userAgeSelected;
            }

            if (typeof vm.profileTypeSelected !== 'undefined') {
                vm.query['audience_profile_type'] = vm.profileTypeSelected;
            }

            if (vm.byPassVirtualFair) {
                vm.query['audience_students_virtual_fair_bypass'] = vm.byPassVirtualFair;
            }
            if (vm.isATokenAudience) {
                vm.query['audience_students_virtual_fair_token_audience'] = vm.isATokenAudience;
            }
            if (vm.byPassPhysicalFair) {
                vm.query['audience_students_physical_fair_bypass'] = vm.byPassPhysicalFair;
            }

            if (vm.userFilterTypeSelected.id === 'student' || vm.userFilterTypeSelected.id === 'institution' || vm.userFilterTypeSelected.id === 'agent') {
                vm.query['audience_students_cities'] = (vm.countryRegionCitiesSelected === [] ? {} : vm.countryRegionCitiesSelected);
                vm.query["audience_avoided_students_cities"] = (vm.countryRegionCitiesAvoidedSelected === [] ? {} : vm.countryRegionCitiesAvoidedSelected);
            }

          } else {
              if (typeof vm.courseSelected !== 'undefined') {
                  vm.query['course'] = {
                      interest_course: [],
                      interest_language: [],
                      profile_type: []
                  };
                  if (typeof vm.courseSelected.interest_course !== 'undefined') {
                      vm.query['course'].interest_course = [vm.courseSelected.interest_course[0]];
                  } else {
                      delete vm.query['course'].interest_course;
                  }
                  if (typeof vm.courseSelected.interest_language !== 'undefined') {
                      vm.query['course'].interest_language = [vm.courseSelected.interest_language[0]];
                  } else {
                      delete vm.query['course'].interest_language;
                  }
                  if (typeof vm.courseSelected.profile_type !== 'undefined') {
                      vm.query['course'].profile_type = [vm.courseSelected.profile_type[0]];
                  } else {
                      delete vm.query['course'].profile_type;
                  }
              }
          }

              if(typeof vm.userStudiedAbroadSelected !== 'undefined') {
                  if(vm.userStudiedAbroadSelected.name !== ' ') {
                      vm.query['audience_students_studied_abroad'] = vm.userStudiedAbroadSelected;
                  } else {
                      vm.query['audience_students_studied_abroad'] = [];
                  }
              }

              if(typeof vm.userWhoPaysSelected !== []) {
                  vm.query['audience_students_who_pays'] = vm.userWhoPaysSelected;
              }
              if(typeof vm.userHowMuchSelected !== []) {
                  vm.query['audience_students_how_much'] = vm.userHowMuchSelected;
              }

              /* STUDENTS -> VIRTUAL FAIR */
              if(typeof vm.virtualFairNotRegisteredSelected !== []) {
                  vm.query['audience_students_virtual_fair_not_registered'] = vm.virtualFairNotRegisteredSelected;
              }
              if(typeof vm.virtualFairRegisteredSelected !== []) {
                  vm.query['audience_students_virtual_fair_registered'] = vm.virtualFairRegisteredSelected;
              }
              if(typeof vm.attendedVirtualFairSelected !== 'undefined') {
                  if(vm.attendedVirtualFairSelected.name !== ' ' && vm.attendedVirtualFairSelected.name !== 'Both') {
                      vm.query['audience_students_virtual_fair_attended'] = vm.attendedVirtualFairSelected;
                  } else {
                      vm.query['audience_students_virtual_fair_attended'] = [];
                  }
              }
              if(typeof vm.confirmedVirtualFairSelected !== 'undefined') {
                  if(vm.confirmedVirtualFairSelected.name !== ' ' && vm.confirmedVirtualFairSelected.name !== 'Both') {
                      vm.query['audience_students_virtual_fair_confirmed'] = vm.confirmedVirtualFairSelected;
                  } else {
                      vm.query['audience_students_virtual_fair_confirmed'] = [];
                  }
              }
              if(typeof vm.micrositeVirtualFairSelected !== 'undefined') {
                  if(vm.micrositeVirtualFairSelected.id !== ' ') {
                      vm.query['audience_students_virtual_fair_microsite'] = vm.micrositeVirtualFairSelected;
                  } else {
                      vm.query['audience_students_virtual_fair_microsite'] = [];
                  }
              }
              if (vm.byPassVirtualFair) {
                vm.query['audience_students_virtual_fair_bypass'] = vm.byPassVirtualFair;
              }
              if (vm.isATokenAudience) {
                vm.query['audience_students_virtual_fair_token_audience'] = vm.isATokenAudience;
              }

              /* STUDENTS -> PHYSICAL FAIR */
              if(typeof vm.physicalFairNotRegisteredSelected !== 'undefined') {
                  vm.query['audience_students_physical_fair_not_registered'] = vm.physicalFairNotRegisteredSelected;
              }
              if(typeof vm.physicalFairRegisteredSelected !== []) {
                  vm.query['audience_students_physical_fair_registered'] = vm.physicalFairRegisteredSelected;
              }
              if(typeof vm.registeredAtPhysicalFairSelected !== 'undefined') {
                  if(vm.registeredAtPhysicalFairSelected.name !== ' ') {
                      vm.query['audience_students_physical_fair_registered_at'] = vm.registeredAtPhysicalFairSelected;
                  } else {
                      vm.query['audience_students_physical_fair_registered_at'] = [];
                  }
              }
              if(typeof vm.confirmedPhysicalFairSelected !== 'undefined') {
                  if(vm.confirmedPhysicalFairSelected.name !== ' ') {
                      vm.query['audience_students_physical_fair_confirmed'] = vm.confirmedPhysicalFairSelected;
                  } else {
                      vm.query['audience_students_physical_fair_confirmed'] = [];
                  }
              }
              if(typeof vm.attendedPhysicalFairSelected !== 'undefined') {
                  if(vm.attendedPhysicalFairSelected.name !== '') {
                      vm.query['audience_students_physical_fair_attended'] = vm.attendedPhysicalFairSelected;
                  } else {
                      vm.query['audience_students_physical_fair_confirmed'] = [];
                  }
              }
              if (vm.byPassPhysicalFair) {
                vm.query['audience_students_physical_fair_bypass'] = vm.byPassPhysicalFair;
              }
              /* STUDENTS -> SEMINAR */
              if(typeof vm.seminarRegisteredSelected !== 'undefined') {
                  if(vm.seminarRegisteredSelected.name !== ' ') {
                      vm.query['audience_students_seminar'] = vm.seminarRegisteredSelected;
                  }
              }
              if(typeof vm.seminarConfirmedSelected !== 'undefined') {
                  if(vm.seminarConfirmedSelected.name !== ' ') {
                      vm.query['audience_students_seminar_confirmed'] = vm.seminarConfirmedSelected;
                  }
              }
          }
          if(typeof vm.userInterestedCountrySelected !== 'undefined') {
              vm.query['audience_students_country'] = vm.userInterestedCountrySelected;
          }
          if(typeof vm.userInterestedProfileTypesSelected !== 'undefined') {
              vm.query['audience_students_studied_profile_type'] = vm.userInterestedProfileTypesSelected;
          }

          /* INSTITUTIONS */
          if(typeof vm.userCountrySelected !== 'undefined') {
              vm.query['audience_country'] = vm.userCountrySelected;
          }
          if(typeof vm.userHaveAPlanSelected !== 'undefined') {
              vm.query['audience_have_a_plan'] = vm.userHaveAPlanSelected;
          }
          if(vm.isCalculate) {
              vm.isCalculate = false;
              vm.calculateAudience(vm.query);
          } else {
              if(!vm.edit){
                  vm.createCampaign(vm.query);
              } else {
                  vm.query['id'] = $stateParams.audienceId;
                  vm.updateCampaign(vm.query);
              }
          }
    }

    function createCampaign(query) {
        AudienceService.calculateAudience(query).then(function(response){
            vm.resultCalculate = response.data;
            if(vm.userFilterTypeSelected.id !== 'student') {
                // vm.resultCalculate[0] = {'total':response.data['total']};
            }
            query['calculate_email'] = vm.resultCalculate.total_email;
            query['calculate_sms'] = vm.resultCalculate.total_sms;

            AudienceService.saveAudience(query).then(function(response){
                vm.campaingInsertedId = response.data;
                $scope.$emit('SaveAudience',{message:vm.campaingInsertedId});
                toastr.success('Successfully saved!');
                if(typeof vm.embed === 'undefined' || vm.embed === false)
                    $state.go("root.emails.audiences");
            }).catch(function(err) {
            });
        }).catch(function(err) {
        });

    }

    function clearPhysicalFairFields() {
        if(vm.physicalFairRegisteredSelected.length === 0) {
            vm.registeredAtPhysicalFairSelected = [];
            vm.confirmedPhysicalFairSelected = [];
            vm.attendedPhysicalFairSelected = [];
        }
    }

    function clearVirtualFairFields() {
        if(vm.virtualFairRegisteredSelected.length === 0) {
            vm.attendedVirtualFairSelected = [];
            vm.confirmedVirtualFairSelected = [];
            vm.micrositesVirtualFair = [];
        }
        vm.physicalFairNotRegisteredSelected = [];
        vm.physicalFairRegisteredSelected = [];
        vm.registeredAtPhysicalFairSelected = [];
        vm.confirmedPhysicalFairSelected = [];
        vm.attendedPhysicalFairSelected = [];
        vm.byPassPhysicalFair = false;
        vm.micrositeVirtualFairSelected = [];
        vm.checkVirtualFairLength();
    }

    function updateCampaign(query) {
        AudienceService.calculateAudience(query).then(function(response){
            vm.resultCalculate = response.data;
            query['calculate_email'] = vm.resultCalculate.total_email;
            query['calculate_sms'] = vm.resultCalculate.total_sms;
            AudienceService.updateAudience(query).then(function(response){
                vm.campaingInsertedId = response.data;
                toastr.success('Successfully updated!');
                $state.go("root.emails.audiences");
            }).catch(function(err) {
            });
        }).catch(function(err) {
        });
    }

    function selectPhysicalFair () {
        ExpoService.getExposAudience().then(function(response){
            vm.physicalFairList = response.data;
        }).catch(function(err) {
        });
    }

    function getMicrositesByVirtualExpo () {
      vm.checkVirtualFairLength();
      let query = vm.virtualFairRegisteredSelected;
      VirtualFairService.getMicrositesByVirtualExpoId(query).then(function(response){
          vm.micrositesVirtualFair = response.data;
      }).catch(function(err) {
      });
      return;
    }

    function checkVirtualFairLength() {
      if (vm.isATokenAudience && vm.virtualFairRegisteredSelected.length > 1){
        vm.micrositeVirtualFairSelected = [];
        vm.virtualFairRegisteredSelected[0] = vm.virtualFairRegisteredSelected[1];
        vm.virtualFairRegisteredSelected.pop();
        vm.getMicrositesByVirtualExpo();
      }
      return;
    }

    function selectVirtualFair () {
        ExpoService.getExposVirtualFair().then(function(response){
            vm.virtualFairList = response.data;
            vm.checkVirtualFairLength();
        }).catch(function(err) {
        });
    }

    function onChangeFilter(param) {
        if(param == 'physicalFair') {
            vm.virtualRequired = false;
            vm.virtualFairSelected = '';
        } else {
            vm.physicalRequired = false;
            vm.physicalFairSelected = '';
        }
    }

    function onChangeisATokenAudience() {
      vm.virtualFairRegisteredSelected = [];
      vm.attendedVirtualFairSelected = [];
      vm.confirmedVirtualFairSelected = [];
      if(vm.isATokenAudience) {
          vm.virtualFairNotRegisteredSelected = [];
          vm.physicalFairNotRegisteredSelected = [];
          vm.physicalFairRegisteredSelected = [];
          vm.registeredAtPhysicalFairSelected = [];
          vm.confirmedPhysicalFairSelected = [];
          vm.attendedPhysicalFairSelected = [];
          vm.byPassVirtualFair = true;
          vm.byPassPhysicalFair = false;
          vm.byPassPhysicalFair = '';
          vm.seminarRegisteredSelected = [];
          vm.seminarConfirmedSelected = [];
          return;
      }
      vm.micrositeVirtualFairSelected = [];
      vm.micrositesVirtualFair = [];
      return;
  }

    function setPage (pageNo) {
        vm.currentPage = pageNo;
    }

    function calculate () {
        vm.isCalculate = true;

        vm.getByFilter();
    }

    function calculateAudience(query){
        AudienceService.calculateAudience(query).then(function(response){
            vm.resultCalculate = response.data;
            query['calculate_email'] = vm.resultCalculate.total_email;
            query['calculate_sms'] = vm.resultCalculate.total_sms;
        }).catch(function(err) {
        });
    }

    function selectProfiles () {
        ProfileTypeService.getProfilesType().then(function(response){
            vm.profileTypeList = response.data;
            vm.profileTypeList.unshift({id: "-1", alias: " ", name: "", full_name: " "});
        }).catch(function(err) {
        });
    }

    function pageChanged (pageNo) {
        vm.page = vm.currentPage;
        vm.getByFilter();
    }

    activate();
  }
})();
